import { CircularProgress, Box } from "@mui/material";
import styles  from './CircularBox.styles';

const CircularBox= () => {
  return (
    <Box sx={styles.box}>
      <CircularProgress color="primary" size={60} />
    </Box>
  )
}

export default CircularBox;